import React from 'react';
import CustomModal from '../../../components/custom-modal/CustomModal';
import CustomButton, { ButtonType } from '../../../components/custom-button/CustomButton';
import { ReactComponent as GreenFilledTickIcon } from '../../../assets/icons/GreenFilledTickIcon.svg';
import { NavCloseIcon } from 'assets/icons';

interface TeamCreationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onInviteMembers: () => void;
  onSkip: () => void;
}

const TeamCreationSuccessModal: React.FC<TeamCreationSuccessModalProps> = ({
  open,
  onClose,
  onInviteMembers,
  onSkip
}) => {
  return (
    <CustomModal open={open} closeModal={onClose} className="" width="md:w-[343px]" enableOutsideClick={false}>
      <div className="relative flex flex-col items-center gap-4 px-4 py-[30px]">
        <NavCloseIcon className="absolute top-4 right-4 cursor-pointer" onClick={onClose} />
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#27AE601A]">
          <GreenFilledTickIcon className="h-11 w-11" />
        </div>

        <div className="flex flex-col items-center gap-10">
          <h2 className="text-17px font-semibold text-successHighlight">Team created successfully</h2>
          <p className="text-center text-xl font-semibold text-headingGray">
            Would you like to invite members to your team?
          </p>
        </div>

        <div className="flex w-full flex-col gap-3">
          <CustomButton
            id="invite-members-btn"
            type={ButtonType.PRIMARY}
            className="h-12 w-full"
            childrenContainerStyles="text-17px"
            onClick={onInviteMembers}>
            Yes, invite members
          </CustomButton>
          <CustomButton
            id="skip-invite-btn"
            type={ButtonType.SECONDARY}
            className="h-12 w-full"
            childrenContainerStyles="text-17px"
            onClick={onSkip}>
            Skip
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default TeamCreationSuccessModal;
